export interface UserPagePayload {
  pageKey: string;
  pageName: string;
  pagePermitted: boolean;
  methods: Array<UserMethodPayload>;
}

export interface UserMethodPayload {
  methodKey: string;
  methodName: string;
  methodPermitted: boolean;
}

export class User {
  id: string;
  sectors: Array<string>;
  employeeId: string;
  email: string;
  photo: string;
  isActive: boolean;
  tempPass: boolean;
  role: string;
  name: string;
  sector: string;
  description: string;
  phone: string;
  type: string;
  permittedPages: Array<string>;
  permittedMethods: Array<string>;

  constructor(user: any) {
    this.id = user.id || user.userId || undefined;
    this.sectors = user.sectors || [];
    this.employeeId = user.employeeId || undefined;
    this.email = user.email || undefined;
    this.photo = user.photo || undefined;
    this.isActive = user.isActive || undefined;
    this.tempPass = user.tempPass || undefined;
    this.role = user.role || undefined;
    this.name = user.name || undefined;
    this.sector = user.sector || undefined;
    this.description = user.description || undefined;
    this.phone = user.phone || undefined;
    this.type = user.type || undefined;
    this.permittedPages = user.permittedPages || undefined;
    this.permittedMethods = user.permittedMethods || undefined;
  }
}

